import * as React from 'react'
import { cn } from '@/lib/utils'

/** A data table in a card: hairline border, subtle header, dense rows. */
export function Table({ ref, className, ...props }: React.ComponentProps<'table'>) {
  return (
    <div className="overflow-x-auto rounded-lg border border-border bg-card shadow-card">
      <table ref={ref} className={cn('w-full text-body', className)} {...props} />
    </div>
  )
}

export function TableHeader({ ref, className, ...props }: React.ComponentProps<'thead'>) {
  return <thead ref={ref} className={cn('bg-subtle text-left', className)} {...props} />
}

export function TableBody({ ref, className, ...props }: React.ComponentProps<'tbody'>) {
  return <tbody ref={ref} className={className} {...props} />
}

export function TableRow({ ref, className, ...props }: React.ComponentProps<'tr'>) {
  return (
    <tr
      ref={ref}
      className={cn('border-t border-border first:border-t-0 [tbody_&]:hover:bg-subtle', className)}
      {...props}
    />
  )
}

export function TableHead({ ref, className, ...props }: React.ComponentProps<'th'>) {
  return (
    <th
      ref={ref}
      className={cn('h-9 px-3 text-caption font-medium whitespace-nowrap text-muted-foreground', className)}
      {...props}
    />
  )
}

export function TableCell({ ref, className, ...props }: React.ComponentProps<'td'>) {
  return <td ref={ref} className={cn('h-10 px-3 py-1.5 align-middle', className)} {...props} />
}
